import { createAction, handleActions } from 'redux-actions';
import { PATH_DELIMITER } from '../../constant/Constant';

const BASE = 'table-no-page-box';
export const INIT_NO_PAGE_GRID = BASE + PATH_DELIMITER + 'INIT_NO_PAGE_GRID';
export const SET_NO_PAGE_CONTROL = BASE + PATH_DELIMITER + 'SET_NO_PAGE_CONTROL';
export const SET_NO_PAGE_GRID_DATA = BASE + PATH_DELIMITER + 'SET_NO_PAGE_GRID_DATA';

export const initNoPageGrid = createAction(INIT_NO_PAGE_GRID);
export const handleNoPageControl = createAction(SET_NO_PAGE_CONTROL);
export const handleNoPageGridData = createAction(SET_NO_PAGE_GRID_DATA);

export const defaultControl = {
    columns: [],
    onRowDoubleClick: null,
    onRowClick: null,
    params: {},
};

export const defaultGridData = {
    rows: [],
    page: 0,
    pageSize: 100,
    totalCount: 0,
};

const initialState = {
    gridData: defaultGridData,
    control: defaultControl,
};

const module = handleActions(
    {
        [INIT_NO_PAGE_GRID]: () => initialState,
        [SET_NO_PAGE_CONTROL]: (state, { payload: control }) => ({ ...state, control }),
        [SET_NO_PAGE_GRID_DATA]: (state, { payload: gridData }) => ({ ...state, gridData }),
    },
    initialState,
);

export default module;
